import { Grid, Typography } from '@mui/material';
import { PqrTimesDataProps } from './props';
import { usePqrTimesData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrTimesData = (props: PqrTimesDataProps) => {
    const {
        formik,
        receptionChannels,
        types,
        halfs,
        subtypeDps,
        procedures,
        typeDays,
        typeStatus,
    } = usePqrTimesData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Estados
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeStatus)}
                    label="Estado de la Regla"
                    name="status"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('status', value)
                    }
                />
            </Grid>

            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Proceso
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(receptionChannels)}
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('receptionChannel', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(types)}
                    label="Tipo PQR"
                    name="type"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type}
                    errors={formik.errors.type}
                    value={formik.values.type}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('type', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(halfs)}
                    label="Medio"
                    name="half"
                    size="small"
                    required
                    disabled={halfs.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.half}
                    errors={formik.errors.half}
                    value={formik.values.half}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('half', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(subtypeDps)}
                    label="Subtipo DP"
                    name="subtypeDp"
                    size="small"
                    required
                    disabled={subtypeDps.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.subtypeDp}
                    errors={formik.errors.subtypeDp}
                    value={formik.values.subtypeDp}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('subtypeDp', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(procedures)}
                    label="Trámite"
                    name="procedure"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.procedure}
                    errors={formik.errors.procedure}
                    value={formik.values.procedure}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('procedure', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typeDays)}
                    label="Fecha base para calculo de días"
                    name="typeDay"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeDay}
                    errors={formik.errors.typeDay}
                    value={formik.values.typeDay}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeDay', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={8}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    disabled
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={12}>
                <FieldText
                    label="Observación"
                    name="observation"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                    rows={3}
                />
            </Grid>
        </Grid>
    );
};
